import { z } from "zod";

import { chillnnNewPasswordZodSchema } from "@/components/features/_shared/validation-schema/validation-schema";

export const authInvitationCompanySignUpInputZodSchema = z.object({
	email: z.string().email({ message: "正しいメールの形式ではありません" }),
	password: chillnnNewPasswordZodSchema,
});

export type AuthInvitationCompanySignUpInputType = z.infer<typeof authInvitationCompanySignUpInputZodSchema>;
